// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status-shard[data-v-b2ceee36]{background-color:#212529!important;border:none!important;height:3.5em;width:3.5em}.status-legend[data-v-b2ceee36] .icon-shape{padding:.5em 0;width:1em}.status-alert.alert-success[data-v-b2ceee36]{background-color:#28b97b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
